import { apiClient } from "@/lib/apiClient";

/** POST-Download (CSV oder verschlüsseltes ZIP) – Dateiname aus Content-Disposition. */
export async function downloadPost(url, body, fallbackName = "export.csv") {
  const res = await apiClient.post(url, body, { responseType: "blob" });
  const cd = res.headers?.["content-disposition"] || "";
  const m = /filename="?([^";]+)"?/.exec(cd);
  const name = m ? m[1] : fallbackName;
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
  return name;
}

/** Fehlertext aus einer Blob-Fehlerantwort lesen. */
export async function blobErrorDetail(e, fallback = "Export fehlgeschlagen") {
  try {
    const txt = await e.response?.data?.text?.();
    return JSON.parse(txt || "{}").detail || fallback;
  } catch {
    return fallback;
  }
}
